export const LABEL_DELIMITER = " • " as const;
